// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/CampaignDeal/index.css
// module id = 2559
// module chunks = 0